import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import {
    Box,
    createStyles, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, Icon,
    IconButton, Input, InputAdornment, InputLabel, makeStyles, MenuItem, Radio, RadioGroup, Select, TextField, Theme, Typography
} from '@material-ui/core';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBR from 'date-fns/locale/pt-BR';

import { InfluencerContext } from '../NewsContext';

import { ClassificationInfluencerModel } from '../../../Models/ClassificationInfluencerModel';
import { HomeContext } from '../../Home/HomeContext';
import { NewsLoadingContext } from '../NewsLoadingContext';
import { InfluencerModel } from '../../../Models/InfluencerModel';
import { format } from 'date-fns';
import { InfluencersAuxiliarResponse } from '../../../Models/InfluencerAuxiliarModel';
import InfluencerService from '../../../Services/InfluencerService';

import { CampaignModel } from '../../../Models/CampaignModel';
import { ClassificationCampaignModel } from '../../../Models/ClassificationCampaignModel';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) => createStyles({
    itens: {
        width: '100%',
        color: 'primary',
    },
    itemData: {
        width: '100%',
        color: 'primary',
        paddingBottom: theme.spacing(1.5),

    },
    linkColor: {
        color: '#2C64D0',
        textOverflow: 'ellipsis',
        '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
        },
    },
    editText: {
        textOverflow: 'ellipsis',
    },
    yellowBackground: {
        backgroundColor: theme.palette.warning.light
    },
    outsideGrid: {
        paddingTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    loading: {
        minHeight: '20vh'
    },
    linksPaperError: {
        padding: theme.spacing(3),
        border: `1px solid ${theme.palette.error.main}`,
    },
    errorText: {
        paddingLeft: theme.spacing(2)
    }
}));
interface NewsDataProps {
    news: CampaignModel | null;
    setNews: (news: CampaignModel) => void;
    newsCurrentId: number | null;
    setNewsCurrentId: (currentId: number | null) => void;
}

type ErrosFormulario = Partial<Record<keyof CampaignModel, string>>;
export function validateCampaignData(news: CampaignModel) {
    const errors: any = {};
    if (!news.marcaId) errors.marcaId = true;
    if (!news.areaId) errors.areaId = true;
    if (!news.vpId) errors.vp = true;
    if (!news.nome || !news.nome.trim()) errors.nome = true;
    if (!news.objetivo || !news.objetivo.trim()) errors.objetivo = true;
    if (!news.canaisId || !Array.isArray(news.canaisId) || news.canaisId.length === 0) errors.canaisICE = true;
    if (!news.periodoCampanha) errors.periodoCampanha = true;
    if (
        news.envolvimentoFiguraPublica === null ||
        news.envolvimentoFiguraPublica === undefined ||
        news.envolvimentoFiguraPublica === ''
    ) errors.envolvimentoFiguraPublica = true;
    if (!news.abrangenciaId && news.abrangenciaId !== 0) errors.abrangenciaId = true;

    return errors;
}
function toBrasiliaISOString(date: Date) {
    const offsetMs = 3 * 60 * 60 * 1000;
    const brasiliaDate = new Date(date.getTime() - offsetMs);
    return brasiliaDate.toISOString().slice(0, 19); // 'YYYY-MM-DDTHH:mm:ss'
}

export default function CampaignData({ news, setNews, }: NewsDataProps) {
    const classes = useStyles();

    const newsLoadingContext = React.useContext(NewsLoadingContext);
    const homeContext = React.useContext(HomeContext);
    const clientEnable = homeContext.influencerClientEnable;
    const [filters, setFilters] = React.useState<InfluencersAuxiliarResponse>();
    const [erros, setErros] = React.useState<ErrosFormulario>({} as ErrosFormulario);
    const [loading, setLoading] = React.useState(false);

    const [nomeDisabled, setNomeDisabled] = React.useState(true);
    const [nomeFocused, setNomeFocused] = React.useState(false);

    const [urlPerfilDisabled, setUrlPerfilDisabled] = React.useState(true);
    const [urlPerfilFocused, setUrlPerfilFocused] = React.useState(false);

    const [iniciativaDisabled, setIniciativaDisabled] = React.useState(true);
    const [iniciativaFocused, setIniciativaFocused] = React.useState(false);

    const [objetivoContratacaoDisabled, setObjetivoContratacaoDisabled] = React.useState(true);
    const [objetivoContratacaoFocused, setObjetivoContratacaoFocused] = React.useState(false);



    React.useEffect(() => {
        setLoading(true);
        if (clientEnable) {
            InfluencerService.getInfluencersBrandByClient(clientEnable.id_cliente)
                .then((res: AxiosResponse) => {
                    setFiltersData(res.data);

                    setLoading(false);
                })
                .catch((error: AxiosError) => { setLoading(false); homeContext.showError('', error); });
        }

    }, []);

    const setFiltersData = (data: InfluencersAuxiliarResponse) => {
        setFilters(data);
    };

    const handleChange = (prop: keyof ClassificationCampaignModel) => (event: React.ChangeEvent<HTMLInputElement>) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        setNews({ ...news, [prop]: event.target.value });
    };

    const handleChangeSelect = (prop: keyof ClassificationCampaignModel) =>
        (event: React.ChangeEvent<{ value: unknown }>) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore
            setNews({ ...news, [prop]: event.target.value as string });
        };

    const handleChangeDate = (prop: keyof CampaignModel) =>
        (date: Date | null) => {
            if (date) {
                if (news) {
                    setNews({ ...news, [prop]: toBrasiliaISOString(date) });
                }
            }
        };



    const validarCampos = (): ErrosFormulario => {
        const novosErros: ErrosFormulario = {};

        const camposObrigatorios: (keyof CampaignModel)[] = [
            'area',
            'marca',
            'vp',
            'nome',
            'url_perfil',
            'iniciativa',
            'finalidade',
            'formato',
            'canais',
            'abrangencia',
        ];

        camposObrigatorios.forEach((campo) => {
            if (news) {
                const valor = news[campo];
                if (typeof valor === 'string' && !valor.trim()) {
                    novosErros[campo] = 'Campo obrigatório.';
                } else if (valor === null || valor === undefined) {
                    novosErros[campo] = 'Campo obrigatório.';
                }
            }
        });
        return novosErros;
    };

    const getDate = () => {
        return (
            <Grid item xs={6}>
                <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils}>
                    <DatePicker
                        id="news-date"
                        variant="inline"
                        value={news?.dataAnalise}
                        inputVariant="outlined"
                        label="Data de upload"
                        minDate={new Date('0000-00-00')}
                        onChange={(date) =>
                            date !== null ? '' : ''
                        }
                        InputProps={{
                            readOnly: true,
                        }}
                        format="dd/MM/yyyy"
                        className={classes.itemData}
                    />
                </MuiPickersUtilsProvider>
            </Grid>
        );
    };

    const getNomeSolicitante = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="nomeSolicitante"
                        value={news?.solicitante}
                        onChange={() => { return; }}
                        label="Nome Solicitante"
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const getResponsavelReputacao = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="responsavelReputacao"
                        value={news?.responsavelReputacao}
                        onChange={() => { return; }}
                        label="Responsável Reputação"
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const getEmail = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="E-mail"
                        value={news?.email}
                        onChange={() => { return; }}
                        label="E-mail"
                        variant="outlined"
                        InputProps={{
                            readOnly: true,
                        }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const getDataRecebimento = () => {
        const dataAtualFormatada = news?.dataRecebimento ? format(new Date(news.dataRecebimento), 'dd/MM/yyyy') : '';
        return (
            <Grid item xs={4}>
                <TextField
                    id="news-date"
                    label="Data"
                    value={dataAtualFormatada}
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                        readOnly: true,
                    }}
                    fullWidth
                />
            </Grid>
        );
    };



    const getNomeFiguraPublica = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="nomeCampanha"
                        value={news?.nome}
                        onChange={handleChange('nome')}
                        label="Nome da Campanha ou projeto"
                        variant="outlined"
                        disabled={nomeDisabled}
                        className={classes.itens}
                        onBlur={() => { setNomeDisabled(true); setNomeFocused(false); }}
                        inputRef={input => nomeFocused && input && input.focus()}
                        InputProps={{
                            endAdornment: (nomeDisabled &&
                                <InputAdornment position="end">
                                    <IconButton onClick={() => { setNomeDisabled(!nomeDisabled); setNomeFocused(true); }}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                </InputAdornment>)
                        }}
                    />
                    {erros.nome && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };


    const getObservacoes = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="observacaoes"
                        value={news?.observacoes || ''}
                        onChange={handleChange('observacoes')}
                        label="Observações"
                        variant="outlined"
                        multiline
                        minRows={3}
                        maxRows={3}
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens} />
                </Grid>
            </>
        );
    };

    const selectMarca = () => {
        const isEmpty = news?.marcaId === null || news?.marcaId === undefined || news?.marcaId === 0;

        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.marcaId || isEmpty}
                >
                    <Autocomplete
                        id="marca-autocomplete"
                        options={filters?.marcas ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.marcas?.find(m => m.id_aux === news?.marcaId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                marcaId: newValue ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Marca"
                                variant="outlined"
                                error={!!erros.marcaId || isEmpty}
                                required
                            />
                        )}
                    />
                    {((erros.marcaId || isEmpty)) && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const selectArea = () => {
        const isEmpty = news?.areaId === null || news?.areaId === undefined || news?.areaId === 0;
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={Boolean(erros.areaId) || isEmpty}
                >
                    <Autocomplete
                        id="area-autocomplete"
                        options={filters?.area ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.area?.find(a => a.id_aux === news?.areaId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                areaId: newValue ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Área"
                                variant="outlined"
                                error={Boolean(erros.areaId) || isEmpty}
                                required
                                helperText={(Boolean(erros.areaId) || isEmpty) ? 'Este campo é obrigatório.' : ''}
                            />
                        )}
                    />
                </FormControl>
            </Grid>
        );
    };

    const selectVp = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.vp}
                >
                    <Autocomplete
                        id="vp-autocomplete"
                        options={filters?.vp ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.vp?.find(v => v.id_aux === news?.vpId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                vpId: newValue ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="VP"
                                variant="outlined"
                                error={!!erros.vp}
                                required
                            />
                        )}
                    />
                    {erros.vp && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };


    const selectCanais = () => {
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required
                    error={!!erros.canaisICE}
                >
                    <Autocomplete
                        multiple
                        id="canais-autocomplete"
                        options={filters?.canais ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.canais?.filter((c) => news?.canaisId?.some((n: any) => n.id_aux === c.id_aux)) || []}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                canaisId: newValue
                                    .filter((c) => typeof c.id_aux === 'number')
                                    .map((c) => ({ id_aux: c.id_aux as number })),
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Canais de divulgação"
                                variant="outlined"
                                error={!!erros.canaisICE}
                                required
                            />
                        )}
                        disableCloseOnSelect
                    />
                    {erros.canaisICE && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };

    const getPublicoAlvo = () => {
        return (
            <>
                <Grid item xs={4}>
                    <TextField
                        id="publicoAlvo"
                        value={news?.publicoAlvo || ''}
                        onChange={handleChange('publicoAlvo')}
                        label="Público-alvo"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        className={classes.itens}
                        required
                    />
                </Grid>
            </>
        );
    };

    const getPeriodoCampanha = () => {
        const isEmpty = !news?.periodoCampanha || news.periodoCampanha.trim() === '';
        return (
            <Grid item xs={8}>
                <Grid container spacing={4}>
                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils} >
                            <DatePicker
                                id="periodo-campanha-inicio"
                                variant="inline"
                                value={news?.periodoCampanha ?? null}
                                inputVariant="outlined"
                                label="Início do Período da campanha"
                                minDate={new Date(0)}
                                clearable
                                emptyLabel=''
                                onChange={handleChangeDate('periodoCampanha')}
                                format="dd/MM/yyyy"
                                className={classes.itens}
                                required error={!!erros.periodoCampanha}
                            />
                            {erros.periodoCampanha && (
                                <FormHelperText>Este campo é obrigatório.</FormHelperText>
                            )}
                        </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <MuiPickersUtilsProvider locale={ptBR} utils={DateFnsUtils} >
                            <DatePicker
                                id="periodo-campanha-fim"
                                variant="inline"
                                value={news?.periodoCampanhaFim ?? null}
                                inputVariant="outlined"
                                label="Fim do Período da campanha"
                                minDate={news?.periodoCampanha ?? new Date(0)}
                                clearable
                                emptyLabel=''
                                onChange={handleChangeDate('periodoCampanhaFim')}
                                format="dd/MM/yyyy"
                                className={classes.itens}
                                required error={!!erros.periodoCampanhaFim}
                            />
                            {erros.periodoCampanhaFim && (
                                <FormHelperText>Este campo é obrigatório.</FormHelperText>
                            )}
                        </MuiPickersUtilsProvider>
                    </Grid>
                </Grid>
            </Grid>
        );
    };


    const selectEnvolvimentoCampanha = () => {
        const isEmpty = news?.envolvimentoFiguraPublica === null || news?.envolvimentoFiguraPublica === undefined || news?.envolvimentoFiguraPublica === '';
        return (
            <>
                <Grid item xs={8}>
                    <FormControl
                        variant="outlined"
                        fullWidth
                        required error={!!erros.envolvimentoFiguraPublica || isEmpty}
                    >
                        <InputLabel id="envolvimento-campanha" style={{ color: 'black', fontSize: '14px' }} >A campanha envolverá a contratação de figuras públicas (influenciadores ou celebridades)?</InputLabel>
                        <Select
                            labelId="envolvimento-campanha"
                            id="envolvimento-campanha"
                            value={news?.envolvimentoFiguraPublica ?? ''}
                            label="A campanha envolverá a contratação de figuras públicas (influenciadores ou celebridades)?"
                            onChange={handleChangeSelect('envolvimentoFiguraPublica')}
                            style={{
                                outline: 'none',
                                borderBottom: 'none',
                            }}
                        >
                            <MenuItem value={undefined}>Selecione</MenuItem>
                            <MenuItem value={1}>Sim</MenuItem>
                            <MenuItem value={0}>Não</MenuItem>
                        </Select>
                        {(erros.envolvimentoFiguraPublica || isEmpty) && (
                            <FormHelperText>Este campo é obrigatório.</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
            </>
        );
    };
    const selectAbrangencia = () => {
        const isEmpty = news?.abrangenciaId === null || news?.abrangenciaId === undefined;
        return (
            <Grid item xs={4}>
                <FormControl
                    variant="outlined"
                    style={{ width: '100%' }}
                    required error={!!erros.abrangenciaId || isEmpty}
                >
                    <Autocomplete
                        id="abrangencia-autocomplete"
                        options={filters?.abrangencia ?? []}
                        getOptionLabel={(option) => option.descricao || ''}
                        value={filters?.abrangencia?.find(a => a.id_aux === news?.abrangenciaId) || null}
                        onChange={(_, newValue) => {
                            if (!news) return;
                            setNews({
                                ...news,
                                abrangenciaId: newValue && typeof newValue.id_aux === 'number' ? newValue.id_aux : 0,
                                id: news.id ?? 0
                            });
                        }}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Abrangência"
                                variant="outlined"
                                error={!!erros.abrangenciaId || isEmpty}
                                required
                            />
                        )}
                    />
                    {(erros.abrangenciaId || isEmpty) && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </FormControl>
            </Grid>
        );
    };



    const getObjetivoContratacao = () => {
        return (
            <>
                <Grid item xs={12}>
                    <TextField
                        id="objetivoContratacao"
                        value={news?.objetivo}
                        label="Objetivo/ conceito da iniciativa"
                        variant="outlined"
                        onChange={handleChange('objetivo')}
                        disabled={objetivoContratacaoDisabled}
                        className={classes.itens}
                        multiline
                        minRows={3}
                        maxRows={3}
                        onBlur={() => { setObjetivoContratacaoDisabled(true); setObjetivoContratacaoFocused(false); }}
                        inputRef={input => objetivoContratacaoFocused && input && input.focus()}
                        InputProps={{
                            endAdornment: (objetivoContratacaoDisabled &&
                                <InputAdornment position="end">
                                    <IconButton onClick={() => { setObjetivoContratacaoDisabled(!objetivoContratacaoDisabled); setObjetivoContratacaoFocused(true); }}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                </InputAdornment>)
                        }}
                    />
                    {erros.objetivo && (
                        <FormHelperText>Este campo é obrigatório.</FormHelperText>
                    )}
                </Grid>
            </>
        );
    };


    return (
        <>
            <Grid>
                <Grid
                    container
                    spacing={3}
                    alignItems="flex-start" >
                    {getResponsavelReputacao()}
                    {getNomeSolicitante()}
                    {getEmail()}
                    {getDataRecebimento()}
                    {selectArea()}
                    {selectMarca()}
                    {selectVp()}
                    {getNomeFiguraPublica()}
                    {selectCanais()}
                    {getObjetivoContratacao()}
                    {getPublicoAlvo()}
                    {getPeriodoCampanha()}
                    {selectEnvolvimentoCampanha()}
                    {selectAbrangencia()}
                    {getObservacoes()}
                </Grid>
            </Grid>
        </>
    );
}